import React, { useEffect, useState } from "react";
import { Grid, Stack, Typography } from "@mui/material";
import { useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
//Srcs
import "./attendanceheader.scss";
import FirstShareImg from "../../Assets/icon_dashboard/Group_40.png";
import SecoundShareImg from "../../Assets/icon_dashboard/Group_24.png";
import ThirdShareImg from "../../Assets/icon_dashboard/Group_25.png";
import FourthShareImg from "../../Assets/icon_dashboard/Group_26.png";
import { currencyFormat } from "../../Function/DynamicFn";
import {
  GET_ACCOUNT_INCOME_DASHBOARD,
  GET_OTHERS_INCOME_DASHBOARD,
  GET_TOTAL_INCOME_BY_YEAR,
  GET_TODAY_INCOME,
  GET_TOTAL_STUDENT_OF_SERVICE_TO_TPAY,
  GET_TOTAL_AMOUT_TO_PAY_TODAY
} from "../../Schema/Dashboard";

export default function AttendanceHeader({ academicYearId }) {

  const [loading, setLoading] = useState(true)
  const [totalIncomeByYear, setTotalIncomeByYear] = useState();
  const [todayIncome, setTodayIncome] = useState();
  const [totalStudent, setTotalStudent] = useState()
  const [totalAmoutToPay, setTotalAmountToPay] = useState()

  const navigate = useNavigate();

  const { refetch: refetchIncomeByYear } = useQuery(GET_TOTAL_INCOME_BY_YEAR, {
    variables: {
      academicYearId: academicYearId ?? "",
    },
    onCompleted: ({ getTotalIncomeByYear }) => {
      setTotalIncomeByYear(getTotalIncomeByYear);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const { refetch: refetchIncomeToday } = useQuery(GET_TODAY_INCOME, {
    onCompleted: ({ todayIncome }) => {
      setTodayIncome(todayIncome);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  const { refetch: refetchTotalStudent } = useQuery(GET_TOTAL_STUDENT_OF_SERVICE_TO_TPAY, {
    variables: {
      academicYearId: academicYearId ?? "",
    },
    onCompleted: ({ totalStudentOfServiceToPayToday }) => {
      setLoading(false)
      setTotalStudent(totalStudentOfServiceToPayToday);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });
  const { refetch: refetchTotalAmount } = useQuery(GET_TOTAL_AMOUT_TO_PAY_TODAY, {
    variables: {
      academicYearId: academicYearId ?? "",
    },
    onCompleted: ({ totalAmountOfServiceToPayToday }) => {
      setLoading(false)
      setTotalAmountToPay(totalAmountOfServiceToPayToday);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  // console.log("totalIncomeByYear", totalIncomeByYear);

  useEffect(() => {
    refetchIncomeToday();
  }, []);

  useEffect(() => {
    refetchTotalAmount();
    refetchTotalStudent();
    refetchIncomeByYear();
  }, [academicYearId]);

  return (
    <Grid container spacing={3} className="header-container">
      <Grid item xs={12} sm={6} xl={3}>
        <Stack
          direction="row"
          spacing={1}
          className="stack-container-first"
          sx={{ cursor: "pointer" }}
          onClick={() => navigate("/income")}
        >
          <Stack direction="column" justifyContent="center">
            <img
              src={FirstShareImg}
              alt="FirstShareImg"
              className="front-icon"
            />
          </Stack>
          <Stack direction="column" justifyContent="space-between">
            <Typography className="share-number">
              $ {currencyFormat(totalIncomeByYear)}
            </Typography>
            <Typography className="share-des">Income By Year</Typography>
          </Stack>
        </Stack>
      </Grid>

      <Grid item xs={12} sm={6} xl={3}>
        <Stack
          direction="row"
          spacing={1}
          className="stack-container-second"
          sx={{ cursor: "pointer" }}
          onClick={() => navigate("/income")}
        >
          <Stack direction="column" justifyContent="center">
            <img
              src={SecoundShareImg}
              alt="SecoundShareImg"
              className="front-icon"
            />
          </Stack>
          <Stack direction="column" justifyContent="space-between">
            <Typography className="share-number">
              $ {currencyFormat(todayIncome)}
            </Typography>
            <Typography className="share-des">Income Today</Typography>
          </Stack>
        </Stack>
      </Grid>

      <Grid item xs={12} sm={6} xl={3}>
        <Stack
          direction="row"
          spacing={1}
          className="stack-container-fourth"
          sx={{ cursor: "pointer" }}
          onClick={() => navigate("/send-notification")}
        >
          <Stack direction="column" justifyContent="center">
            <img
              src={FourthShareImg}
              alt="FourthShareImg"
              className="front-icon"
            />
          </Stack>
          <Stack direction="column" justifyContent="space-between">
            <Typography className="share-number">
              {totalStudent} នាក់
            </Typography>
            <Typography className="share-des">Total Student to Pay Today</Typography>
          </Stack>
        </Stack>
      </Grid>

      <Grid item xs={12} sm={6} xl={3}>
        <Stack
          direction="row"
          spacing={1}
          className="stack-container-third"
          sx={{ cursor: "pointer" }}
          onClick={() => navigate("/send-notification")}
        >
          <Stack direction="column" justifyContent="center">
            <img
              src={ThirdShareImg}
              alt="ThirdShareImg"
              className="front-icon"
            />
          </Stack>
          <Stack direction="column" justifyContent="space-between">
            <Typography className="share-number">
              $ {currencyFormat(totalAmoutToPay)}
            </Typography>
            <Typography className="share-des">Total Amount to Pay Today</Typography>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
}
